module.exports = __webpack_public_path__ + "img/borderWavesBlue.372a6baf.svg";